import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { ImageModule } from '@df/module-image/image.module';
import { Basket } from '@df/session/api/basket/basket';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { Subscription } from 'rxjs';
import { Product } from '../product.decorator';
import { ITEM_STATUS_CURRENT_ID, ProductStockDescriptionService } from './product-stock-description.service';

@Component({
    selector: 'product-stock-levels',
    templateUrl: 'product-stock-levels.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, TranslationModule, ImageModule, ICmsClientModule]
})
export class ProductStockLevelsComponent implements OnInit, OnDestroy {
    @Input()
    product?: Product<IProductDataV3>;

    @Input()
    qty?: number;

    private subscriptions = new Subscription();

    constructor(
        private basket: Basket,
        private changeDetectorRef: ChangeDetectorRef,
        private productStockDescriptionService: ProductStockDescriptionService
    ) {}

    get isMattressWithSimbaBeds(): boolean {
        return this.product?.data?.vendorno === 40293;
    }

    get isSalable(): boolean {
        if (this.product) {
            return this.product.isSalable(this.qty);
        }
        return false;
    }

    get stockClearanceDescription(): string {
        if (this.product?.isClearanceOnline && this.maxQty <= 10) return `Only ${this.maxQty} left in stock`;
        else return 'In Stock';
    }

    get displayMaxQtyMessage(): boolean {
        if (this.product && this.maxQty && !this.product.isClearanceOnline) {
            return !this.product.isSalable(this.qty) || this.maxQty < 5;
        }
        return false;
    }
    get maxQty(): number {
        if (this.product) {
            return Math.max(this.product.getStockQty(false, undefined, true), 0);
        }
        return 0;
    }

    get stockDescription(): string {
        return typeof this.qty !== 'undefined' && this.product?.id
            ? this.productStockDescriptionService.get(this.qty, this.product.id)
            : '';
    }
    get isInStock(): boolean {
        return typeof this.qty !== 'undefined' && !!this.product && this.productStockDescriptionService.isInStock(this.qty, this.product);
    }
    get isItemStatusCurrent(): boolean {
        return this.product?.data?.item_status === ITEM_STATUS_CURRENT_ID;
    }
    get displayedStockDescription(): string {
        return !this.isSalable ? 'Sold out' : this.isInStock ? this.stockClearanceDescription : this.stockDescription;
    }
    get showMadeToOrderInfoModalButton(): boolean {
        return this.productStockDescriptionService.isMadeToOrder(this.product?.id as number);
    }

    ngOnInit(): void {
        this.subscriptions.add(this.basket.subscribe(() => this.changeDetectorRef.detectChanges()));
    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
